import type { IconSvgObject } from './types';

const PackageRemoveIcon: IconSvgObject = [
  ["path", { d: "M2.50391 6V18L11.5 22M11.5 22V10M11.5 22L14 21M20.5039 6.01357V11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 10L20.5 6L11.5 2L2.5 6L11.5 10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 4L7 8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5.5 11L8 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M16.5 14L21.5 19M16.5 19L21.5 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default PackageRemoveIcon;
